import { useEffect, useState } from "react";
import { Typography, Box, Button, Card, Divider, Chip } from "@mui/material";
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  getFormTemplateDetailsRequest,
  getFormTemplateDetailsSuccess,
} from "../../../../redux/form-templates/slice";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../../components/loading/loading";
import AddTemplate from "../add-template/add-template";
import ContactSpectrum from "../../../../components/contact-spectrum/constact-spectrum";
import { getInspectionServicesRequest } from "../../../../redux/inspection-firms/slice";

export default function FormTemplateSettings() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();

  const [showEditTemplate, setShowEditTemplate] = useState(false);

  const { loading, formTemplateDetails } = useSelector(
    (state: any) => state.formTemplates
  );
  const { inspectionServices } = useSelector(
    (state: any) => state.inspectionFirms
  );

  useEffect(() => {
    if (inspectionServices.length === 0)
      dispatch(getInspectionServicesRequest());
    dispatch(getFormTemplateDetailsSuccess({ response: null }));
    dispatch(getFormTemplateDetailsRequest({ id: state?.id }));
  }, []); // eslint-disable-line

  const getInspectionTypeLabel = (value: string) => {
    const findType = inspectionServices.find(
      (t: any) => t?.inspectionType === value
    );
    return findType ? findType?.displayName : "-";
  };

  return (
    <>
      <ContactSpectrum />
      <Breadcrumb />
      <Typography sx={{ ml: 2 }} className="title">
        {formTemplateDetails?.displayName}
      </Typography>
      <Box
        sx={{ mt: 3 }}
        className="clients-header"
        justifyContent={"space-between"}
      >
        <Typography sx={{ fontSize: 14, color: "rgba(0, 0, 0, 0.6)" }}>
          SETTINGS
        </Typography>
        <Button
          id="add-button"
          variant="contained"
          onClick={() =>
            navigate(
              `/form-templates/${formTemplateDetails?.displayName}/form-builder`,
              {
                state: formTemplateDetails,
              }
            )
          }
        >
          View & Edit Form
        </Button>
      </Box>

      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Settings</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={() => setShowEditTemplate(true)}
          >
            Edit
          </Button>
        </Box>
        <Box className="display-name-layout">
          <Typography className="label-txt">Template Name</Typography>
          <Typography>{formTemplateDetails?.displayName}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Category</Typography>
          <Typography>{formTemplateDetails?.inspectionTypeCategory}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Type</Typography>
          <Typography>
            {getInspectionTypeLabel(formTemplateDetails?.inspectionType)}
          </Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Available Output</Typography>
          <Box>
            {formTemplateDetails?.availableOutputs &&
            formTemplateDetails?.availableOutputs?.length > 0 ? (
              formTemplateDetails?.availableOutputs.map((output: string) => (
                <Typography key={output}>{output}</Typography>
              ))
            ) : (
              <>-</>
            )}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Standard Client Fee</Typography>
          <Typography>{formTemplateDetails?.clientFee}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Standard Inspector Fee</Typography>
          <Typography>{formTemplateDetails?.inspectorFee}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Standard Restrictions</Typography>
          <Box>
            {formTemplateDetails?.restrictions.hasOwnProperty(
              "backgroundCheckDone"
            ) && (
              <Typography display={"flex"} alignItems={"center"}>
                Background Check Completed
                <Chip
                  sx={{ ml: 1 }}
                  size="small"
                  color="primary"
                  variant="outlined"
                  label={
                    formTemplateDetails?.restrictions.backgroundCheckDone
                      ? "True"
                      : "False"
                  }
                />
              </Typography>
            )}
            {formTemplateDetails?.restrictions?.certifications &&
              formTemplateDetails?.restrictions?.certifications?.length > 0 && (
                <Typography display={"flex"} alignItems={"center"} mt={1}>
                  Certifications
                  {formTemplateDetails?.restrictions?.certifications.map(
                    (certification: string) => (
                      <Chip
                        key={certification}
                        sx={{ ml: 1 }}
                        size="small"
                        color="primary"
                        variant="outlined"
                        label={certification}
                      />
                    )
                  )}
                </Typography>
              )}
            {formTemplateDetails?.restrictions?.insurances &&
              formTemplateDetails?.restrictions?.insurances?.length > 0 && (
                <Typography display={"flex"} alignItems={"center"} mt={1}>
                  Insurance Required
                  {formTemplateDetails?.restrictions?.insurances.map(
                    (insurance: string) => (
                      <Chip
                        key={insurance}
                        sx={{ ml: 1 }}
                        size="small"
                        color="primary"
                        variant="outlined"
                        label={insurance}
                      />
                    )
                  )}
                </Typography>
              )}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Always Require 2nd QC</Typography>
          <Typography>
            {formTemplateDetails?.requireSecondQc ? "Yes" : "No"}
          </Typography>
        </Box>
      </Card>

      {showEditTemplate && (
        <AddTemplate
          showDialog={showEditTemplate}
          closeDialog={() => setShowEditTemplate(false)}
          data={formTemplateDetails}
        />
      )}

      {loading && <Loading />}
    </>
  );
}
